<template>
  <div v-if="functionInputList">
    <v-text-field
      v-if="!hideSearch"
      label="Filter"
      v-model="search"
      outlined
      class="mt-5"
    ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="list"
      :search="search"
      class="och-table pb-2"
      sort-by="name"
    >
      <template v-slot:no-data>
        <i>No functions created or associated</i>
      </template>
      <template v-slot:item="{ item }">
        <tr
          @click="
            $router.push({
              name: 'ochinUserSecurityFunctionForm',
              params: {
                functionId: item.id,
              },
            })
          "
          class="och-tableRow"
        >
          <td>{{ item.name }}</td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.id
              )"
              :key="`${item.id}_${index})_type`"
              class="mt-2"
            >
              {{ input.type }}
            </div>
          </td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.id
              )"
              :key="`${item.id}_${index})_point`"
              class="mt-2"
            >
              {{ input.point }}
            </div>
          </td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.id
              )"
              :key="`${item.id}_${index})_value`"
              class="mt-2"
            >
              <span v-if="item.inverted"
                >{{ input.operator }}
                <v-chip class="ml-2" x-small label pill>Inverted</v-chip></span
              >
              <span v-else>{{ input.operator }}</span>
            </div>
          </td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.id
              )"
              :key="`${item.id}_${index})_value`"
              class="mt-2"
            >
              {{ input.value }}
            </div>
          </td>
          <td class="text-right">
            <v-btn
              v-if="showRemoveButton"
              @click.stop="removeFunction(item)"
              icon
              small
            >
              <v-icon small>fas fa-trash</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  computed: {
    showRemoveButton() {
      return !!this.$listeners.remove;
    },
    ...mapGetters({
      filterFunctionInput: "secFunctionInput/filterByAttributeValue",
      filterType: "epicApplicationType/filterByAttributeValue",
      getTypeById: "epicApplicationType/getById",
    }),
    ...mapState({
      functionInputList: state => state.secFunctionInput.list,
    }),
  },
  async created() {
    await Promise.all([this.getFunctionInputList()]);
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Type",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "Item",
          value: "point",
          align: "start",
          sortable: false,
        },
        {
          text: "Operator",
          value: "operator",
          align: "start",
          sortable: false,
        },
        {
          text: "Value",
          value: "value",
          align: "start",
          sortable: false,
        },
        {
          text: " ",
          value: "",
          align: "start",
          sortable: false,
        },
      ],
      search: null,
    };
  },
  methods: {
    navigate(name, params) {
      this.$emit("navigate", { name, params });
    },
    removeFunction(item) {
      this.$emit("remove", item);
    },
    ...mapActions({
      getFunctionInputList: "secFunctionInput/list",
    }),
  },
  props: ["hideSearch", "list"],
};
</script>
